<template>
  <div>
    <wiki-text-block
      :text="block.wikiText"
      :plaintext="plaintext"
      :popover-placement="popoverPlacement"
      :resources="resources"
      :strategies="strategies"
      v-for="(block, index) in wikiTextBlocks"
      :markdown-only="block.markdownOnly && !plaintext"
      :key="index"
      :locked-links="lockedLinkWikiBlock"
      :locked="lockWikiBlock(index)"
      :locked-full="fullyLockWikiBlock(block, index)" />
    <div v-if="hasMultilingualResources && objectId">
      <ResourceLanguageDropdown :object-id="objectId" />
    </div>
  </div>
</template>

<script>
import { breakdownWikiTextBlocks } from '@/util/tokenize_wiki_text'
import WikiTextBlock from '@/components/WikiTextBlock'
import { mapGetters } from 'vuex'
import ResourceLanguageDropdown from '@/components/ResourceLanguageDropdown'

let lockModes = ['default', 'lock_links', 'always_snippet_first_block', 'completely_blur'] // 'default' mode is if there's only one block, we partially blur. If there's more than one block, we only blur blocks after the first one. Other modes are relatively self-explanatory.

export default {
  name: 'WikiText',
  components: {
    WikiTextBlock,
    ResourceLanguageDropdown
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    strategies: {
      type: Object,
      default() {
        return {}
      }
    },
    resources: {
      type: Object,
      default() {
        return {}
      }
    },
    plaintext: {
      type: Boolean,
      default: false
    },
    popoverPlacement: {
      type: String,
      default: 'right'
    },
    locked: {
      type: Boolean,
      default: false
    },
    lockMode: {
      type: String,
      default: 'default',
      validator: mode => lockModes.indexOf(mode) > -1
    },
    objectId: {
      type: String,
      default: ''
    },
  },
  computed: {
    wikiTextBlocks() {
      return breakdownWikiTextBlocks(this.text)
    },
    lockedLinkWikiBlock() {
      return this.locked && this.lockMode === 'lock_links'
    },
    ...mapGetters('goaldetail', ['hasNonEnglishLangById']),
    hasMultilingualResources() {
      if (!this.objectId) return false
      return this.hasNonEnglishLangById(this.objectId)
    }
  },
  methods: {
    lockWikiBlock(index) {
      // special case: Handling the first block if there are multiple blocks
      if (this.wikiTextBlocks.length > 1 && index === 0) {
        return (
          this.locked &&
          ['completely_blur', 'always_snippet_first_block'].indexOf(this.lockMode) > -1
        )
      }
      return this.locked && this.lockMode !== 'lock_links'
    },
    fullyLockWikiBlock(block, index) {
      // fully lock (i.e. no visible snippet) applies if we have more than 1 block OR if there's only a single block and it's just an image
      return (
        this.locked &&
        ((this.wikiTextBlocks.length > 1 && index > 0) ||
          this.isSingleMarkdownImage(block) ||
          this.lockMode === 'completely_blur')
      )
    },
    isSingleMarkdownImage(block) {
      return block.markdownOnly && block.wikiText && block.wikiText.split(' ').length === 1
    }
  }
}
</script>

<style>
.wiki-text-container img {
  max-width: 100%;
}
.wiki-text-token {
  display: inline;
}
.highlight {
  display: inline-block;
  background: #ffff84;
  padding: 2px 4px;
  margin: 1px 0;
}
.highlight.highlight--resource {
  background: #ffd8fc;
}
.language {
  text-align: right;
}
</style>
